import cn from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

export const DiscountLabel: React.FC<{
  discount: number | string | null;
  className?: string;
  inline?: boolean;
  text?: string;
}> = ({ discount, className, inline, text }) => (
  <div
    className={cn(styles.discountLabel, { [styles.inline]: inline }, className)}
  >
    {text || `-${Number(discount)}%`}
  </div>
);

DiscountLabel.displayName = 'Payments/DiscountLabel';
